/**
 * Tags API
 */
import { apiClient } from './client'
import type { Tag, TagCreate, TagUpdate, Holding, WatchlistItem } from '../types'

const BASE_PATH = '/api/tags'

export const tagsApi = {
  list: async (): Promise<Tag[]> => {
    const response = await apiClient.get<Tag[]>(BASE_PATH)
    return response.data
  },

  get: async (tagId: string): Promise<Tag> => {
    const response = await apiClient.get<Tag>(`${BASE_PATH}/${tagId}`)
    return response.data
  },

  create: async (data: TagCreate): Promise<Tag> => {
    const response = await apiClient.post<Tag>(BASE_PATH, data)
    return response.data
  },

  update: async (tagId: string, data: TagUpdate): Promise<Tag> => {
    const response = await apiClient.put<Tag>(`${BASE_PATH}/${tagId}`, data)
    return response.data
  },

  delete: async (tagId: string): Promise<void> => {
    await apiClient.delete(`${BASE_PATH}/${tagId}`)
  },

  getHoldings: async (tagId: string): Promise<Holding[]> => {
    const response = await apiClient.get<Holding[]>(`${BASE_PATH}/${tagId}/holdings`)
    return response.data
  },

  getWatchlist: async (tagId: string): Promise<WatchlistItem[]> => {
    const response = await apiClient.get<WatchlistItem[]>(`${BASE_PATH}/${tagId}/watchlist`)
    return response.data
  },
}

// Helper functions for setting tags on holdings/watchlist
export const holdingTagsApi = {
  set: async (holdingId: string, tagIds: string[]): Promise<string[]> => {
    const response = await apiClient.put<string[]>(`/api/holdings/${holdingId}/tags`, { tag_ids: tagIds })
    return response.data
  },
}

export const watchlistTagsApi = {
  set: async (symbol: string, tagIds: string[]): Promise<string[]> => {
    const response = await apiClient.put<string[]>(`/api/watchlist/${encodeURIComponent(symbol)}/tags`, { tag_ids: tagIds })
    return response.data
  },
}
